import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../api/baseQuery";
import authReducer from "../api/auth/authSlice";
import equiposVentaReducer from "../store/equiposVentaSlice";
import empresaSelectedReducer from "../store/empresaSelectedSlice";

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        auth: authReducer,
        equiposVenta: equiposVentaReducer,
        empresaSelected: empresaSelectedReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
    devTools: true,
});

export type RootState = ReturnType<typeof store.getState>;